import {Button, Card, Spin, Table} from 'antd';
import React from "react";
import moment from "moment";
import {getColumnSearchProps} from "../../util/methods";

class Report extends React.Component {

  state = {
  };

  componentDidMount() {
    this.props.getUnserviceableReport();
  }

  edit = (id) => {
    const {match, history} = this.props;
    this.props.history.push(`/job-card/report/${id}`);
  };

  render() {
    const { loading, report, pagination } = this.props;
    const columns = [
      {
        title: 'Asset Code',
        dataIndex: 'assetCode',
        key: 'assetCode',
        sorter: true,
        width: 100,
        render: (data) => <div>{data}</div>,
        ...getColumnSearchProps({ field: 'assetCode', type: 'String', filterField: 'assetCode' }, this.props.handleFilter, this.props.handleReset, 'Asset')
      },
      {
        title: 'Asset Sub Type',
        dataIndex: 'assetSubType',
        key: 'assetSubType',
        sorter: true,
        ...getColumnSearchProps({ field: 'name', type: 'String', filterField: 'assetSubType' }, this.props.handleFilter, this.props.handleReset, 'EquipmentSubType')
      },
      {
        title: 'Asset Type',
        dataIndex: 'assetType',
        key: 'assetType',
        sorter: true,
        ...getColumnSearchProps({ field: 'name', type: 'String', filterField: 'assetType' }, this.props.handleFilter, this.props.handleReset, 'AssetType')
      },
      {
        title: 'Location',
        dataIndex: 'location',
        key: 'location',
        sorter: true,
        ...getColumnSearchProps({ field: 'name', type: 'String', filterField: 'location' }, this.props.handleFilter, this.props.handleReset, 'Location')
      },
      {
        title: 'Sub Location',
        dataIndex: 'client',
        key: 'client',
        sorter: true,
        ...getColumnSearchProps({ field: 'name', type: 'String', filterField: 'client' }, this.props.handleFilter, this.props.handleReset, 'Client')
      },
      {
        title: 'Unserviceable Since',
        dataIndex: 'complaintDate',
        key: 'complaintDate',
        sorter: true,
        render: (date) => <div>{date ? moment(date).format('DD-MM-YYYY') : ''}</div>,
        ...getColumnSearchProps({ field: 'complaintDate', type: 'Date', filterField: 'complaintDate' }, this.props.handleFilter, this.props.handleReset, 'Complaint')
      },
      {
        title: 'Complaint No',
        dataIndex: 'complaintNo',
        key: 'complaintNo',
        sorter: true,
        ...getColumnSearchProps({ field: 'complaintNo', type: 'String', filterField: 'complaintNo' }, this.props.handleFilter, this.props.handleReset, 'Complaint')
      },
      {
        title: 'Expected Date of Serviceability',
        dataIndex: 'expectedDateOfCompletion',
        key: 'expectedDateOfCompletion',
        sorter: true,
        render: (date) => <div>{date ? moment(date).format('DD-MM-YYYY') : ''}</div>,
        ...getColumnSearchProps({ field: 'expectedDateOfCompletion', type: 'Date', filterField: 'expectedDateOfCompletion' }, this.props.handleFilter, this.props.handleReset, 'JobCard')
      },
      {
        title: 'Days since unserviceable',
        dataIndex: 'complaintDate',
        key: 'dateSinceUnserviceable',
        render: (date) => <div>{date ? moment().diff(moment(date), 'days') : ''}</div>,
        sorter: true,
      },
      {
        title: 'Present Status',
        dataIndex: 'jobCardStatus',
        key: 'jobCardStatus',
        sorter: true,
        render: (data) => <div>{data && data.name}</div>,
      },
      {
        title: 'Complaint Details',
        dataIndex: 'detailsOfComplaint',
        key: 'detailsOfComplaint',
        sorter: true,
      },
      {
        title: 'Damage Cause',
        dataIndex: 'causeOfDamage',
        key: 'causeOfDamage',
        sorter: true,
      },
      {
        title: 'Job Card No',
        dataIndex: 'jobCard',
        key: 'jobCard',
        sorter: true,
        render: (data) => <div>{(data && data._id) ? data && data.jobCardNo : ''}</div>,
        ...getColumnSearchProps({ field: 'jobCardNo', type: 'String', filterField: 'jobCardNo' }, this.props.handleFilter, this.props.handleReset, 'JobCard')
      },
      {
        title: 'Job Card View',
        dataIndex: 'jobCard',
        key: 'job Card View',
        render: (data) => <div>{ data && data._id ? <Button onClick={this.edit.bind(this, data._id)}>Open Job Card</Button> : 'No Job Card'}</div>
      }
    ];

    return (
      <Spin spinning={loading}>
        <Card className={`gx-card-metrics`}>
          <Table columns={columns} dataSource={report} pagination={pagination} onChange={this.props.handleChange} scroll={{x: 1500}}/>
        </Card>
      </Spin>
    );
  }
}


export default Report;
